import FormControlLabel from "@mui/material/FormControlLabel";
import styled from "styled-components";

import { Switch } from "@mui/material";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export enum TextFieldDisplayType {
    Error = "error",
    Success = "success",
    Default = "default",
}

export const StyledFormControlForSwitch = styled(FormControlLabel)`
    && {
        .MuiFormControlLabel-label {
            color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
            display: block;

            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            line-height: 24px;
        }
    }
`;

export const StyledSwitch = styled(Switch)`
    && {
        height: 48px;
        width: 76px;

        .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
            background: ${UIStyleConstants.BLUE_COLOR};
            opacity: 1;
        }

        .MuiSwitch-track {
            background-color: ${UIStyleConstants.WHITE_COLOR};
            opacity: 1;
            border-radius: 12px;
            border: solid 2px ${UIStyleConstants.BLUE_COLOR};
        }

        .MuiSwitch-switchBase {
            padding: 14px;

            .MuiSwitch-thumb {
                border: solid 2px ${UIStyleConstants.WHITE_COLOR};
                background-color: ${UIStyleConstants.BLUE_COLOR};
            }

            &.Mui-checked {
                transform: translateX(28px);

                .MuiSwitch-thumb {
                    background-color: ${UIStyleConstants.BLUE_COLOR};
                }
            }
        }
    }
`;
